// SEO配置文件
export const siteConfig = {
  siteName: '聯漢室內設計工作室',
  siteUrl: 'http://www.lan-hung560.com.tw',
  defaultDescription: '聯漢室內設計工作室 - 專業室內設計與室內裝修團隊，提供住宅設計、商業空間設計、舊屋翻新、系統櫥櫃等服務。服務台東、高雄及高雄市仁武區、三民區，打造有溫度的居住空間。',
  defaultKeywords: '室內設計, 室內裝修, 台灣室內設計, 住宅設計, 商業空間設計, 舊屋翻新, 北歐風格, 現代風格, 工業風格, 新古典風, 民宿設計, 台東室內裝潢設計, 台東舊屋翻新整修, 台東系統櫥櫃工程, 高雄室內裝潢設計, 高雄室內裝修, 高雄舊屋翻新整修, 高雄系統櫥櫃工程, 高雄市仁武區室內裝修, 高雄市三民區室內裝修, 仁武室內設計, 三民區室內設計',
  logo: '/images/logo.png',
  companyInfo: {
    name: '聯漢室內設計工作室',
    phone: '',
    email: '',
    address: '',
    businessHours: '週一至週六 08:00-23:30'
  }
};

export const pagesSEO = {
  home: {
    title: '聯漢室內設計工作室 | 高雄、台東室內設計與室內裝修',
    description: '聯漢室內設計工作室專精住宅設計、商業空間、舊屋翻新與室內裝修服務，服務台東、高雄及高雄市仁武區、三民區等地區，從北歐風格到現代簡約，打造有溫度的理想空間。',
    keywords: '聯漢室內設計, 室內設計公司, 室內裝修, 住宅設計, 商業空間設計, 台灣室內設計, 台東室內裝潢設計, 高雄室內裝潢設計, 高雄室內裝修, 高雄市仁武區室內裝修, 高雄市三民區室內裝修, 仁武室內設計, 三民區室內設計',
    canonical: '/'
  },
  about: {
    title: '關於我們 | 聯漢室內設計工作室 - 專業設計團隊介紹',
    description: '了解聯漢室內設計工作室的設計理念、專業團隊背景與服務特色。我們擁有豐富的設計經驗，致力於為每位客戶打造獨特而溫馨的居住空間。',
    keywords: '關於聯漢, 設計團隊, 室內設計理念, 專業背景, 台東室內設計, 高雄室內設計, 高雄室內裝修',
    canonical: '/about'
  },
  services: {
    title: '設計服務 | 高雄室內裝修、住宅設計、舊屋翻新 - 聯漢室內設計',
    description: '聯漢室內設計提供住宅設計、商業空間設計、室內裝修、舊屋翻新、空間規劃、系統櫥櫃工程等服務，服務台東、高雄及仁武區、三民區等區域。',
    keywords: '室內設計服務, 室內裝修, 住宅設計, 商業空間, 舊屋翻新, 空間規劃, 設計施工, 系統櫥櫃工程, 台東室內裝潢設計, 高雄室內裝潢設計, 高雄市仁武區室內裝修, 高雄市三民區室內裝修, 高雄仁武舊屋翻新, 高雄三民舊屋翻新',
    canonical: '/services'
  },
  process: {
    title: '設計流程 | 聯漢室內設計工作室 - 專業設計流程介紹',
    description: '了解聯漢室內設計的專業設計流程：初步諮詢、現場丈量、設計規劃、施工監造，透明化流程讓您安心託付您的空間改造計畫。',
    keywords: '設計流程, 設計步驟, 室內設計過程, 室內裝修流程, 諮詢服務, 台東室內設計流程, 高雄室內設計流程',
    canonical: '/process'
  },
  projects: {
    title: '設計作品 | 高雄、台東室內設計案例 - 聯漢室內設計',
    description: '欣賞聯漢室內設計的精選作品集，包含北歐風格、現代風格、工業風格、新古典風、民宿飯店、住宅與商業空間案例，服務台東、高雄、仁武區、三民區等地區。',
    keywords: '室內設計作品, 設計案例, 北歐風格, 現代風格, 工業風格, 新古典風, 民宿設計, 台東室內裝潢設計, 高雄室內裝潢設計, 高雄室內裝修案例, 仁武室內設計, 三民區室內設計',
    canonical: '/projects'
  },
  contact: {
    title: '聯絡我們 | 高雄、台東室內設計與裝修諮詢 - 聯漢室內設計',
    description: '歡迎聯絡聯漢室內設計工作室，預約住宅設計、商業空間、舊屋翻新與室內裝修諮詢。服務台東、高雄及高雄市仁武區、三民區等地區客戶。',
    keywords: '聯絡方式, 設計諮詢, 免費估價, 室內設計聯絡, 台東室內設計諮詢, 高雄室內設計諮詢, 高雄室內裝修推薦, 仁武室內設計諮詢, 三民區室內設計諮詢',
    canonical: '/contact'
  }
};

// 結構化資料 JSON-LD
export const getOrganizationStructuredData = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": siteConfig.siteName,
  "url": siteConfig.siteUrl,
  "logo": `${siteConfig.siteUrl}${siteConfig.logo}`,
  "description": siteConfig.defaultDescription,
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": siteConfig.companyInfo.phone,
    "contactType": "customer service",
    "availableLanguage": ["Chinese"]
  },
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "TW",
    "addressLocality": siteConfig.companyInfo.address
  },
  "sameAs": []
});

export const getWebsiteStructuredData = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": siteConfig.siteName,
  "url": siteConfig.siteUrl,
  "description": siteConfig.defaultDescription,
  "potentialAction": {
    "@type": "SearchAction",
    "target": `${siteConfig.siteUrl}/search?q={search_term_string}`,
    "query-input": "required name=search_term_string"
  }
});

export const getLocalBusinessStructuredData = () => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": `${siteConfig.siteUrl}/#organization`,
  "name": siteConfig.siteName,
  "image": `${siteConfig.siteUrl}${siteConfig.logo}`,
  "url": siteConfig.siteUrl,
  "description": siteConfig.defaultDescription,
  "priceRange": "$$",
  "openingHours": siteConfig.companyInfo.businessHours,
  "telephone": siteConfig.companyInfo.phone,
  "email": siteConfig.companyInfo.email,
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "TW",
    "addressLocality": siteConfig.companyInfo.address
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "",
    "longitude": ""
  },
  "areaServed": [
    {
      "@type": "City",
      "name": "台東"
    },
    {
      "@type": "City",
      "name": "高雄"
    },
    {
      "@type": "AdministrativeArea",
      "name": "高雄市仁武區"
    },
    {
      "@type": "AdministrativeArea",
      "name": "高雄市三民區"
    },
    {
      "@type": "Country",
      "name": "Taiwan"
    }
  ],
  "serviceType": [
    "室內設計",
    "室內裝修",
    "住宅設計",
    "商業空間設計",
    "舊屋翻新",
    "室內裝潢設計",
    "舊屋翻新整修",
    "系統櫥櫃工程",
    "高雄市仁武區室內裝修",
    "高雄市三民區室內裝修"
  ]
});
